import React from "react";

interface SuffixIconProps {
    hasError?: boolean;
    hasValue?: boolean;
    suffixSrc?: string;
    checkmarkSrc: string;
    warningSrc: string;
}

const SuffixIcon: React.FC<SuffixIconProps> = ({
    hasError,
    hasValue,
    suffixSrc,
    checkmarkSrc,
    warningSrc,
}) => {
    let icon = null;

    if (hasError) {
        icon = warningSrc;
    } else if (hasValue) {
        icon = checkmarkSrc;
    } else if (suffixSrc) {
        icon = suffixSrc;
    }

    return (
        <div className="center">{icon && <img src={icon} alt="status icon" />}</div>
    );
};

export default SuffixIcon;
